import * as colors from './browser-colors.json';

type RGB = {
    r: number;
    g: number;
    b: number;
};

export function parseCssColorToRgb(color: string): RGB | null {
    color = color.toLowerCase().trim();

    // Check for hex color
    if (color.startsWith('#')) {
        return hexToRgb(color);
    }

    // Check for browser-supported color
    if (color in colors) {
        return hexToRgb(colors[color]);
    }

    // Check for rgb() and rgba()
    const rgbMatch = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*\d*\.?\d+)?\)$/);
    if (rgbMatch) {
        return {
            r: parseInt(rgbMatch[1], 10),
            g: parseInt(rgbMatch[2], 10),
            b: parseInt(rgbMatch[3], 10)
        };
    }

    // Check for hsl() and hsla()
    const hslMatch = color.match(/^hsla?\((\d+),\s*(\d+)%?,\s*(\d+)%?(?:,\s*\d*\.?\d+)?\)$/);
    if (hslMatch) {
        return hslToRgb(
            parseInt(hslMatch[1], 10),
            parseInt(hslMatch[2], 10),
            parseInt(hslMatch[3], 10)
        );
    }

    // If nothing passes, return null
    return null;
}

export function calculateRgbLuminance(rgb: RGB): number {
    // Standard color luminance from RGB calculation values
    return 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
}

// Color convert calculations

function hexToRgb(hex: string): RGB | null {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map((c) => c + c).join('');
    }

    if (hex.length === 6 || hex.length === 8) {
        const bigint = parseInt(hex, 16);
        const r = Math.floor(bigint / (256 * 256)) % 256;
        const g = Math.floor(bigint / 256) % 256;
        const b = bigint % 256;
        return {r, g, b};
    }

    return null;
}

function hslToRgb(h: number, s: number, l: number): RGB {
    s /= 100;
    l /= 100;
    const k = (n: number) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n: number) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return {r: Math.round(f(0) * 255), g: Math.round(f(8) * 255), b: Math.round(f(4) * 255)};
}